import React from 'react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { observer } from 'mobx-react';
import './firstViewFormDocument.module.scss';
import { V3Routes } from '../../../routes/index';
import { GoogleAnalyticsClient } from "../../../../commonv2/modules/analytics";

type Props = {};

export const FirstViewForSp = () => {
    return (
        <div styleName="first-view">
            <div styleName="background-image-sp">
                <div styleName="button-box">
                    <a id="button_trial" styleName="button-sp button_trial" href={V3Routes.trialLessons().pathname} target="_blank" />
                    <a
                        id="button_document"
                        styleName="button-sp button_document"
                        href={V3Routes.trialDocument().pathname + '?id=form'}
                        onClick={() => GoogleAnalyticsClient.sendGaEvent('trial', 'view_line_shelikes_document')}
                    />
                </div>
            </div>
        </div>
    );
};

export const FirstViewForPc = () => {
    return (
        <div styleName="first-view">
            <div styleName="background-image-pc">
                <div styleName="button-box">
                    <a id="button_trial" styleName="button-pc button_trial" href={V3Routes.trialLessons().pathname} target="_blank" />
                    <a
                        id="button_document"
                        styleName="button-pc button_document"
                        href={V3Routes.trialDocument().pathname + '?id=form'}
                        onClick={() => GoogleAnalyticsClient.sendGaEvent('trial', 'view_line_shelikes_document')}
                    />
                </div>
            </div>
        </div>
    );
};

@observer
export class FirstViewForDocumentLp extends React.Component<Props> {
    render() {
        const { isSp } = GlobalStatesV3.viewport;
        return isSp ? <FirstViewForSp /> : <FirstViewForPc />;
    }
}
